// assign/my-model
import { postData } from 'src/services/RestApi';

export const apiAccountToGroup = async (values) => {
  const params = {
    accountId: values.accountId,
    groupId: values.groupId
  };
  return await postData('api/account/assign/to/group', params);
};

export const apiCarToAccount = async (values) => {
  const params = {
    carId: values.carId,
    accountId: values.accountId
  };
  return await postData('car/assign/to/account', params);
};

export const apiCarToGroup = async (values) => {
  const params = {
    carId: values.carId,
    groupId: values.groupId,
  };
  return await postData('car/assign/to/group', params);
};